(function(){
  function escapeHtml(value){
    return String(value || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function normalize(value){ return String(value || '').replace(/\s+/g,' ').trim(); }
  var accessoryWordRe = /(zubeh[oö]r|ersatz|tasche|h[uü]lle|schutzh[uü]lle|halter|halterung|adapter|klemme|klammer|fu[ßs]|standfu[ßs]|bodenanker|anker|gewicht|wassergewicht|kreuzfu[ßs]|platte|bodenplatte|stange|mast|rolle|rollen|verbinder|kabel|netzteil|akku|ladekabel|befestigung|montage|saugnapf|spannband|seil|haken|clip|clips|set)/i;
  var markerRe = /(passendes\s+zubeh[oö]r|zubeh[oö]r|dazu\s+passend|passt\s+dazu|passt\s+zu|kompatibel\s+mit|ben[oö]tigt|braucht|erforderlich|geeignet\s+f[uü]r|empfohlene?\s+erg[aä]nzung(en)?|separat\s+erh[aä]ltlich|optional\s+erh[aä]ltlich|nicht\s+enthalten|lieferumfang\s+ohne|erg[aä]nzend)/i;
  function stripNoise(value){
    return normalize(value)
      .replace(/\([^)]*\)/g,' ')
      .replace(/\[[^\]]*\]/g,' ')
      .replace(/\b(passendes|passende|passender|kompatibles|kompatible|empfohlenes|empfohlene|optionales|optionale|separat|erh[aä]ltlich)\b/ig,' ')
      .replace(/\b(zubeh[oö]r|zubeh[öo]rartikel|ersatzteile?|erg[aä]nzungen?|artikel|produkte?|sets?)\b/ig,' ')
      .replace(/\s+/g,' ')
      .replace(/^[\s:;,.\-–]+|[\s:;,.\-–]+$/g,'');
  }
  function cleanCandidate(value){
    var text = stripNoise(value)
      .replace(/^(f[uü]r|mit|zu|zur|zum|als|und|oder|inklusive|inkl\.)\s+/i,'')
      .replace(/[.;:]+$/,'')
      .trim();
    if(text.length < 3 || text.length > 84) return '';
    if(/^(ja|nein|siehe|optional|passend|lieferumfang|hinweis|produkt|artikel)$/i.test(text)) return '';
    if(/^\d+[\s,.]*$/i.test(text)) return '';
    return text;
  }
  function splitCandidateList(value){
    return normalize(value)
      .split(/,|;|\||\s\+\s|\s\/\s|\sund\s|\soder\s|\s&\s/ig)
      .map(cleanCandidate)
      .filter(Boolean);
  }
  function extractCandidates(description){
    var text = String(description || '')
      .replace(/\r/g,'\n')
      .replace(/\u00a0/g,' ')
      .replace(/<br\s*\/?\s*>/ig,'\n')
      .replace(/\s*([:;])\s*/g,'$1 ');
    var raw = [];
    var lines = text.split(/\n|•|\u2022|\u00b7|\|/).map(normalize).filter(Boolean);

    lines.forEach(function(line){
      if(markerRe.test(line) || accessoryWordRe.test(line)) raw.push(line);
    });

    var patterns = [
      /(?:passendes\s+zubeh[oö]r|zubeh[oö]r|dazu\s+passend|passt\s+dazu|passt\s+zu|kompatibel\s+mit|ben[oö]tigt|braucht|erforderlich|empfohlen(?:e|es)?\s+erg[aä]nzung(?:en)?|separat\s+erh[aä]ltlich|optional\s+erh[aä]ltlich|nicht\s+enthalten|lieferumfang\s+ohne)\s*[:\-–]?\s*([^.!?\n]{3,180})/ig,
      /(?:fu[ßs]|standfu[ßs]|bodenanker|anker|gewicht|wassergewicht|tasche|h[uü]lle|halter(?:ung)?|adapter|klemme|platte|rolle|ersatzteil)[^.!?\n]{0,120}/ig
    ];
    patterns.forEach(function(re){
      var m;
      while((m = re.exec(text)) !== null){ raw.push(m[1] || m[0]); }
    });

    var candidates = [];
    raw.forEach(function(line){
      var withoutLead = line.replace(/.*?(zubeh[oö]r|kompatibel\s+mit|passt\s+zu|passt\s+dazu|dazu\s+passend|erg[aä]nzung(en)?|ersatzteile?|geeignet\s+f[uü]r|empfohlen(e|es)?|separat\s+erh[aä]ltlich|optional\s+erh[aä]ltlich|nicht\s+enthalten|lieferumfang\s+ohne|ben[oö]tigt|braucht|erforderlich)\s*[:\-–]?\s*/i, '');
      splitCandidateList(withoutLead).forEach(function(c){
        if(accessoryWordRe.test(c) || markerRe.test(line)) candidates.push(c);
      });
    });

    var seen = Object.create(null);
    return candidates.filter(function(item){
      var key = item.toLowerCase();
      if(seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0,10);
  }
  function accessoryScore(product, term){
    var title = String(product && product.title || '').toLowerCase();
    var type = String(product && product.type || product.product_type || '').toLowerCase();
    var hay = title + ' ' + type;
    var termText = String(term || '').toLowerCase();
    if(!accessoryWordRe.test(hay) && !accessoryWordRe.test(termText)) return 0;
    var score = 0;
    if(accessoryWordRe.test(title)) score += 4;
    if(accessoryWordRe.test(type)) score += 2;
    termText.split(/\s+/).filter(function(w){ return w.length > 3; }).forEach(function(w){ if(hay.indexOf(w) !== -1) score += 1; });
    return score;
  }
  function productCard(product){
    var image = product && product.featured_image && product.featured_image.url ? product.featured_image.url + '&width=180' : '';
    var title = product && product.title ? product.title : '';
    var url = product && product.url ? product.url : '#';
    var imgHtml = image ? '<img src="'+escapeHtml(image)+'" alt="'+escapeHtml(title)+'" loading="lazy">' : '<span>'+escapeHtml(title.slice(0,1))+'</span>';
    return '<a class="lmp-accessory-mini lmp-accessory-mini--auto" href="'+escapeHtml(url)+'">' +
      '<span class="lmp-accessory-mini__image">'+imgHtml+'</span>' +
      '<span class="lmp-accessory-mini__content"><strong>'+escapeHtml(title)+'</strong><em>Als Zubehör ansehen</em></span>' +
    '</a>';
  }
  function searchChip(term, resultsUrl){
    var href = (resultsUrl || '/search') + '?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
    return '<a class="lmp-accessory-search-chip" href="'+escapeHtml(href)+'"><strong>'+escapeHtml(term)+'</strong><span>Zubehör suchen</span></a>';
  }
  function fetchProducts(endpoint, term){
    var base = String(endpoint || '/search/suggest').replace(/\.json$/,'').replace(/\/$/,'') + '.json';
    var params = new URLSearchParams({
      q: term,
      'resources[type]': 'product',
      'resources[limit]': '8',
      'resources[limit_scope]': 'each',
      'resources[options][fields]': 'title,product_type,variants.title,tag,body',
      'resources[options][unavailable_products]': 'last'
    });
    return fetch(base + '?' + params.toString(), { headers: { Accept: 'application/json' } })
      .then(function(res){ return res.ok ? res.json() : null; })
      .then(function(data){ return data && data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : []; })
      .catch(function(){ return []; });
  }
  function init(root){
    var json = root.querySelector('[data-lmp-accessory-description]');
    var grid = root.querySelector('[data-lmp-accessory-auto-grid]');
    var title = root.querySelector('[data-lmp-accessory-auto-title]');
    if(!json || !grid) return;
    var description = '';
    try { description = JSON.parse(json.textContent || '""'); } catch(e) { description = json.textContent || ''; }
    var currentTitle = root.getAttribute('data-current-title') || '';
    var terms = extractCandidates(description);

    /* V49: Keine ähnlichen Produkte mehr raten. Ohne konkrete Zubehörnamen aus der Beschreibung bleibt die Box leer/hilfreich. */
    if(!terms.length) return;

    var endpoint = root.getAttribute('data-search-url') || '/search/suggest';
    var resultsUrl = root.getAttribute('data-results-url') || '/search';
    var currentUrl = root.getAttribute('data-current-url') || '';
    var currentTitleLower = currentTitle.toLowerCase();
    var seenTerms = Object.create(null);
    terms = terms.map(normalize).filter(function(term){
      var key = term.toLowerCase();
      if(!term || seenTerms[key]) return false;
      seenTerms[key] = true;
      return true;
    }).slice(0,8);

    Promise.all(terms.map(function(term){ return fetchProducts(endpoint, term).then(function(products){ return {term: term, products: products}; }); }))
      .then(function(groups){
        var html = '';
        var seenProducts = Object.create(null);
        var usedTerms = Object.create(null);
        groups.forEach(function(group){
          var best = null;
          var bestScore = 0;
          (group.products || []).forEach(function(p){
            var pTitle = String(p && p.title || '');
            if(!p || !p.url || p.url === currentUrl || pTitle.toLowerCase() === currentTitleLower || seenProducts[p.url]) return;
            var score = accessoryScore(p, group.term);
            if(score > bestScore){ best = p; bestScore = score; }
          });
          if(best && bestScore >= 2){
            seenProducts[best.url] = true;
            html += productCard(best);
          } else if(!usedTerms[group.term.toLowerCase()]){
            usedTerms[group.term.toLowerCase()] = true;
            html += searchChip(group.term, resultsUrl);
          }
        });
        if(html){
          if(title) title.hidden = false;
          grid.innerHTML = html;
          root.classList.add('is-ready');
          var empty = root.closest('.lmp-accessory-card') && root.closest('.lmp-accessory-card').querySelector('[data-lmp-accessory-empty]');
          if(empty) empty.hidden = true;
        }
      });
  }
  function ready(){ document.querySelectorAll('[data-lmp-accessory-auto]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
